import http from '../http-common'

class DataService {
  getListOrgOption() {
    return http.get('/option/orglist')
  };

  getEventList(filterSett) {
    let filter = '';
    if (filterSett.dat1) {
      filter += '&dat1=' + filterSett.dat1;
    }
    if (filterSett.dat2) {
      filter += '&dat2=' + filterSett.dat2;
    }
    if (filterSett.org_id) {
      filter += '&org_id=' + filterSett.org_id;
    }
    return http.get('/site/ekplistCache?' + filter.substring(1))
    .catch((error) => {
      console.log(error.message)
    })
  }
}

export default new DataService()
